import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const PrivacyPolicy: React.FC = () => {
  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Privacy Policy" pagesub="Privacy Policy" />
            <section className="legal-content pt-120 pb-120">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="legal-content-wrap">
                      <div className="sec-title sec-title-center about-sec-title about-sec-title-two mb-60">
                        <span className="sub-title mb-10">Legal</span>
                        <h2 className="title">Privacy Policy</h2>
                      </div>

                      <p className="legal-meta" style={{ textAlign: "center", color: "rgba(255,255,255,0.5)", marginBottom: 60 }}>
                        Last updated: April 20, 2026
                      </p>

                      <div className="legal-section">
                        <h3 className="legal-heading">1. Introduction</h3>
                        <p className="legal-text">
                          TorqAI Technologies Inc. ("TorqAI," "we," "us," or "our") respects your privacy and is committed
                          to protecting your personal information. This Privacy Policy explains how we collect, use, disclose,
                          and safeguard your information when you use our website at torqai.ca and our AI-powered services
                          (CAPRO, VAPRO, HAPRO, SAPRO, TAPRO, and INPRO).
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">2. Information We Collect</h3>
                        <p className="legal-text">
                          We may collect the following types of information:
                        </p>
                        <ul className="legal-list">
                          <li><strong>Personal Information:</strong> Name, email address, phone number, company name, and billing
                            information that you provide when creating an account, subscribing to a plan, or contacting us.</li>
                          <li><strong>Usage Data:</strong> Information about how you interact with our Services, including pages
                            visited, features used, session duration, and referral sources.</li>
                          <li><strong>Device Information:</strong> IP address, browser type, operating system, and device identifiers
                            collected automatically when you access our website.</li>
                          <li><strong>Communication Data:</strong> Records of correspondence when you contact our support team,
                            submit a form, or respond to our communications.</li>
                          <li><strong>AI Interaction Data:</strong> Data processed through our AI agents, including voice call
                            recordings (CAPRO), social media content (VAPRO), candidate information (HAPRO), sales interactions
                            (SAPRO), training simulations (TAPRO), and business analytics data (INPRO).</li>
                        </ul>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">3. How We Use Your Information</h3>
                        <p className="legal-text">
                          We use the information we collect to:
                        </p>
                        <ul className="legal-list">
                          <li>Provide, maintain, and improve our Services</li>
                          <li>Process transactions and manage your subscription</li>
                          <li>Communicate with you about updates, offers, and support</li>
                          <li>Analyze usage patterns to enhance user experience</li>
                          <li>Train and improve our AI models and algorithms</li>
                          <li>Comply with legal obligations and enforce our Terms of Service</li>
                          <li>Detect, prevent, and address technical issues and security threats</li>
                        </ul>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">4. Data Sharing and Disclosure</h3>
                        <p className="legal-text">
                          We do not sell your personal information to third parties. We may share your information in the
                          following limited circumstances:
                        </p>
                        <ul className="legal-list">
                          <li><strong>Service Providers:</strong> Trusted third-party vendors who assist us in operating our
                            Services, such as cloud hosting, payment processing, and analytics providers.</li>
                          <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process, or to
                            protect the rights, property, or safety of TorqAI, our users, or others.</li>
                          <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of all or
                            a portion of our assets, where your information may be transferred as a business asset.</li>
                        </ul>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">5. Data Security</h3>
                        <p className="legal-text">
                          We implement industry-standard security measures to protect your personal information, including
                          encryption in transit and at rest, access controls, regular security audits, and secure data centers.
                          However, no method of transmission over the Internet or electronic storage is 100% secure, and we
                          cannot guarantee absolute security.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">6. Data Retention</h3>
                        <p className="legal-text">
                          We retain your personal information for as long as your account is active or as needed to provide
                          you with our Services. We may also retain and use your information as necessary to comply with legal
                          obligations, resolve disputes, and enforce our agreements. When data is no longer needed, we securely
                          delete or anonymize it.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">7. Your Rights and Choices</h3>
                        <p className="legal-text">
                          Depending on your jurisdiction, you may have the following rights regarding your personal information:
                        </p>
                        <ul className="legal-list">
                          <li><strong>Access:</strong> Request a copy of the personal information we hold about you.</li>
                          <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information.</li>
                          <li><strong>Deletion:</strong> Request deletion of your personal information, subject to legal obligations.</li>
                          <li><strong>Portability:</strong> Request a copy of your data in a structured, machine-readable format.</li>
                          <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time using the link
                            in our emails or by contacting us directly.</li>
                        </ul>
                        <p className="legal-text">
                          To exercise any of these rights, please contact us at{" "}
                          <a href="mailto:info@torqai.ca" style={{ color: "var(--color-primary)" }}>info@torqai.ca</a>.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">8. Cookies and Tracking Technologies</h3>
                        <p className="legal-text">
                          We use cookies and similar tracking technologies to collect usage data, remember your preferences,
                          and improve our Services. You can control cookie settings through your browser preferences. Please
                          note that disabling cookies may affect the functionality of certain features.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">9. Third-Party Links</h3>
                        <p className="legal-text">
                          Our Services may contain links to third-party websites or services that are not operated by us.
                          We are not responsible for the privacy practices of these third parties. We encourage you to review
                          the privacy policies of any third-party services you access through our platform.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">10. Children's Privacy</h3>
                        <p className="legal-text">
                          Our Services are not directed to individuals under the age of 18. We do not knowingly collect
                          personal information from children. If we become aware that we have inadvertently collected
                          information from a child, we will take steps to delete it promptly.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">11. International Data Transfers</h3>
                        <p className="legal-text">
                          Your information may be transferred to and processed in countries other than Canada. We ensure
                          that appropriate safeguards are in place to protect your information in accordance with applicable
                          data protection laws, including the Personal Information Protection and Electronic Documents Act (PIPEDA).
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">12. Changes to This Policy</h3>
                        <p className="legal-text">
                          We may update this Privacy Policy from time to time. We will notify you of material changes by
                          posting the updated policy on our website and updating the "Last updated" date. Your continued
                          use of the Services after such changes constitutes your acceptance of the revised policy.
                        </p>
                      </div>

                      <div className="legal-section">
                        <h3 className="legal-heading">13. Contact Us</h3>
                        <p className="legal-text">
                          If you have any questions or concerns about this Privacy Policy, please contact us at:
                        </p>
                        <p className="legal-text">
                          <strong>TorqAI Technologies Inc.</strong><br />
                          30 Charles St W, Toronto, ON<br />
                          Email: <a href="mailto:info@torqai.ca" style={{ color: "var(--color-primary)" }}>info@torqai.ca</a><br />
                          Phone: <a href="tel:+14374475333" style={{ color: "var(--color-primary)" }}>+1 437 447 5333</a>
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default PrivacyPolicy;
